<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<ng-container *ngIf="!isLoadingResults && question$ | async as question">
  <p>
    {{ question | propertyLocalized : ["tooltipAr", "tooltipEn"] | async }}
  </p>

  <div [allowedSummaryType]="['All']">
    <ng-container *ngIf="criterion$ | async as criterion">
      <div
        class="form-custom-warning"
        *ngIf="isSessionNotStarted || !criterion.allQuestionsAnswered"
      >
        <span
          *ngIf="
            isSessionNotStarted && !criterion.allQuestionsAnswered;
            else oneOfThem
          "
        >
          {{
            "forms.common.Criteria.Errors.QuestionsAnsweredAndSessionStarted"
              | translate
          }}
        </span>
        <ng-template #oneOfThem>
          <span *ngIf="isSessionNotStarted">
            {{ "forms.common.Criteria.Errors.SessionStarted" | translate }}
          </span>
          <span *ngIf="!criterion.allQuestionsAnswered">
            {{ "forms.common.Criteria.Errors.QuestionsAnswered" | translate }}
          </span>
        </ng-template>
      </div>
    </ng-container>

    <form [formGroup]="form">
      <div
        *ngIf="
          !isFormDisabled &&
          form.errors?.masarAnswerInvalid &&
          (question.errorAr || question.errorEn)
        "
        class="error form-custom-warning mb-2"
      >
        {{ question | propertyLocalized : ["errorAr", "errorEn"] | async }}
      </div>

      <mat-checkbox formControlName="notApply">
        {{ "forms.common.a1" | translate }}
      </mat-checkbox>
      <br />

      <ng-container *ngIf="!form.controls.notApply.value">
        <div class="evaluatedItems" *ngIf="answers$ | async">
          <table class="table table-bordered">
            <tr class="header">
              <th width="50%" rowspan="2"></th>
              <th rowspan="2">{{ "forms.common.a1" | translate }}</th>
              <th *ngFor="let item of process.evaluationLevels">
                {{
                  item
                    | propertyLocalized : ["arabicLabel", "englishLabel"]
                    | async
                }}
              </th>
            </tr>
            <tr class="header">
              <th *ngFor="let item of process.evaluationLevels">
                {{ item.score }}
              </th>
            </tr>

            <ng-container formArrayName="subAnswers">
              <ng-container
                *ngFor="
                  let questionAndAnswer of subAnswers.controls;
                  let i = index
                "
              >
                <tr [formGroupName]="i">
                  <td>
                    {{
                      question.evaluationItems[i]
                        | propertyLocalized : ["nameAr", "nameEn"]
                        | async
                    }}
                    <mat-icon
                      class="info"
                      *ngIf="question.evaluationItems[i].hasTooltip"
                      [matTooltip]="
                        question.evaluationItems[i]
                          | propertyLocalized : ['tooltipAr', 'tooltipEn']
                          | async
                      "
                    >
                      info
                    </mat-icon>

                    <br />
                    <span
                      *ngIf="
                        !isFormDisabled &&
                        questionAndAnswer.errors?.masarSubAnswerInvalid
                      "
                      class="error"
                    >
                      {{
                        question.evaluationItems[i]
                          | propertyLocalized : ["errorAr", "errorEn"]
                          | async
                      }}
                    </span>
                  </td>
                  <td>
                    <input type="radio" value="" formControlName="score" />
                  </td>
                  <td
                    *ngFor="
                      let option of process.evaluationLevels;
                      let il = index
                    "
                  >
                    <input
                      type="radio"
                      [value]="option.score"
                      formControlName="score"
                    />
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </table>
        </div>
        <br />

        <app-copy-decision
          (clicked)="copy('evaluationJustifications')"
          [enabledCopy]="enabledCopy || enabledCopyToExecutiveSummary"
          [tooltip]="
            enabledCopyToExecutiveSummary
              ? 'forms.common.Criteria.copy'
              : 'forms.common.Criteria.copyEvidenceJustifications'
          "
          [prefix]="
            enabledCopyToExecutiveSummary
              ? 'forms.common.Criteria.ToExecutiveSummary'
              : ''
          "
        >
          <mat-label
            class="font-weight-bold"
            [ngClass]="{ 'field-required': !form.controls.notApply.value }"
          >
            {{ "forms.common.Criteria.EvaluationJustifications" | translate }}
          </mat-label>
        </app-copy-decision>
        <mat-form-field appearance="outline">
          <textarea
            matInput
            cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="3"
            formControlName="evaluationJustifications"
          ></textarea>
        </mat-form-field>

        <ng-container
          *ngIf="
            !!form.controls.evaluationJustifications.value &&
            !decisionInput.disableAttachments
          "
        >
          <div class="d-flex flex-column">
            <mat-label class="font-weight-bold mb-1">
              {{ "forms.common.Criteria.Attachments" | translate }}
            </mat-label>

            <div class="data-table">
              <ng-container formArrayName="evidences">
                <table mat-table [dataSource]="evidences.controls">
                  <ng-container matColumnDef="selected">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox
                        (change)="toggleAllEvidences($event.checked)"
                        *ngIf="evidences.value?.length != 0"
                      ></mat-checkbox>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      [formGroup]="element"
                    >
                      <mat-checkbox
                        formControlName="selected"
                        *ngIf="evidences.value?.length != 0"
                      ></mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="fileName">
                    <th mat-header-cell *matHeaderCellDef>
                      <strong>
                        {{
                          "forms.common.Criteria.fileName" | translate
                        }}</strong
                      >
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <strong
                        class="file"
                        (click)="openFile(element.get('file').value)"
                        >{{ element.get("fileName").value }}</strong
                      >
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="noRecord">
                    <td
                      colspan="2"
                      class="text-center"
                      mat-footer-cell
                      *matFooterCellDef
                    >
                      {{ "table.emptyTable" | translate }}
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                  <tr
                    [hidden]="!!evidences.value?.length"
                    mat-footer-row
                    *matFooterRowDef="
                      evidences.value?.length === 0 ? ['noRecord'] : []
                    "
                  ></tr>
                </table>
                <!-- <div class="evaluatedItems">
                  <span *ngIf="!isFormDisabled && evidences.errors?.evidencesInvalid" class="error">
                    {{'forms.common.You must add at least one item' | translate}}
                  </span>
                </div> -->
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <div class="d-flex justify-content-end" *ngIf="!isFormDisabled">
        <button
          class="mt-3"
          mat-flat-button
          (click)="submit()"
          color="primary"
          [disabled]="form.invalid"
        >
          {{ "forms.common.Criteria.save" | translate }}
        </button>
      </div>
    </form>
  </div>
</ng-container>
